@let label = labelSg();
@let disabled = disabledSg();
@let selected = selectedSg();
@let someSelected = someSelectedSg();

<div class="ds-checkbox">
  <div
    class="ds-checkbox__item"
    (click)="$event.stopPropagation(); !disabled && onCheckboxClickHandler()"
  >
    <div
      [class.ds-checkbox__item--active]="selected || someSelected"
      [class.ds-checkbox__item--disabled]="disabled"
      class="ds-checkbox__item-input"
    >
      @if (selected) {
        <i class="atn-icon atn-check atn-light"></i>
      }

      @if (!selected && someSelected) {
        <i class="atn-icon atn-minus atn-light"></i>
      }
    </div>
    @if (label) {
      <label class="ds-checkbox__item-label">
        {{ label }}
      </label>
    }
  </div>
</div>
